import { getApiUrl } from "./getApiUrl.js";

export function getGqlEndpoint() {
  return `${getApiUrl()}/graphql`;
}
